module.exports = "../images/hero-logo.png?v=7c33c50";